var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ItemTable',{attrs:{"title":"公費","authDiv":_vm.authDiv,"headers":_vm.publicHeaders,"items":_vm.items,"item_class":_vm.publicItemsRowBackground},on:{"makenew":_vm.publicCreate,"repair":_vm.publicRepair,"copy":_vm.publicCopy}})}
var staticRenderFns = []

export { render, staticRenderFns }